import { definePreset } from '@primeng/themes';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Fingerpeg } from '~assets/themes/edl/fingerpeg.theme';

export const VerifyTheme: unknown = definePreset(Fingerpeg, {});
